import React, { memo, ImgHTMLAttributes } from 'react';

const CustomImage = ({ src, alt, ...rest }: ImgHTMLAttributes<HTMLImageElement>): JSX.Element => {
  return (
    <img
      loading="lazy"
      src={src && src !== '' ? src : process.env.REACT_APP_IMAGE_URL}
      alt={alt}
      onError={(e: any) => (e.target.src = process.env.REACT_APP_IMAGE_URL)}
      {...rest}
    />
  );
};

export default memo(CustomImage);
